export default __webpack_public_path__ + "static/media/dollar.a7f80182.svg";